import React from 'react'
import {Accordion} from 'react-bootstrap'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface FAQ {
  question: string
  answer: string
}

interface Props {
  faqs: FAQ[]
}

const HelpFAQSection: React.FC<Props> = ({faqs}) => {
  if (!faqs || faqs.length === 0) return null

  return (
    <div className='help-faq' id='faqs'>
      <h2 className='help-faq-title fw-bold text-gray-900 mb-4'>
        Frequently Asked Questions
      </h2>
      <Accordion>
        {faqs.map((faq, index) => (
          <Accordion.Item key={index} eventKey={String(index)}>
            <Accordion.Header>{faq.question}</Accordion.Header>
            <Accordion.Body>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{faq.answer}</ReactMarkdown>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  )
}

export {HelpFAQSection}
